<template>
  <div class="dashkit">
    <el-form
      style="padding: 0;"
      label-position="top"
      label-width="100px"
    >
      <div class="row no-gutters">
        <div class="col-xs-12 col-md mr-md-3 policy-card__left">
          <div class="card-box px-md-4 policy-card__left__first">
            <div class="single-form booking-policy-form__single-form">
              <el-form-item>
                <div
                  slot="label"
                >
                  운영 시스템
                  <span class="label-description">
                    횟수제는 ‘회’, 포인트제는 ‘P’로 차감 단위가 표시됩니다.
                  </span>
                </div>
                <div
                  class="booking-policy-form__single-form__checkboxs"
                >
                  <div
                    v-if="isWhitePlan"
                    class="setting-item__mask"
                    @click.prevent="detectFunction(RESTRICT_FUNCTION_ID.POINT)"
                  />
                  <el-checkbox
                    border
                    v-model="checker.is_count"
                    true-label="COUNT"
                    false-label="COUNT"
                    @change="checkboxActionHandler"
                  >
                    횟수제
                  </el-checkbox>
                  <el-checkbox
                    border
                    v-model="checker.is_point"
                    true-label="POINT"
                    false-label="POINT"
                    @change="checkboxActionHandler"
                  >
                    포인트제
                  </el-checkbox>
                </div>
              </el-form-item>
              <el-form-item>
                <div slot="label">
                  예약 오픈 시점
                  <span class="label-description">
                    수업일 기준 며칠/주 전, 몇 시부터 예약을 허용할지 정해주세요.
                    <popover placement="bottom">
                      ‘1주, 00:00’로 설정할 경우 (월요일 수업 예시)<br>
                      회원은 1주 전인 월요일 00:00부터 예약을<br>
                      신청할 수 있습니다.<br><br>
                      ‘1일, 00:00’로 설정할 경우 (월요일 수업 예시)<br>
                      회원은 1일 전 일요일 00:00부터 예약을<br>
                      신청할 수 있습니다.<br><br>
                      <a
                        target="_blank"
                        href="https://intercom.help/fiflbox/ko/articles/3454628-%EC%98%88%EC%95%BD-%EC%98%A4%ED%94%88-%EC%8B%9C%EC%A0%90%EC%9D%84-%EB%B3%80%EA%B2%BD%ED%95%98%EA%B3%A0-%EC%8B%B6%EC%96%B4%EC%9A%94"
                        style="color: #9b9b9b;"
                      >
                        더 많은 활용 사례 보기 >
                      </a>
                    </popover>
                  </span>
                </div>
                <div
                  v-if="isWhitePlan || isGreyPlan || isLightGreyPlan"
                  class="setting-item__mask"
                  @click.prevent="detectFunction(RESTRICT_FUNCTION_ID.TIME_OPEN)"
                />
                <el-input-week
                  v-model="form.booking_available_from"
                />

                <div class="el-input-time">
                  <el-time-select
                    v-model="bookingOpenTime"
                    value-format="HH:mm:ss"
                    format="HH:mm"
                    prefix-icon="none"
                    :clearable="false"
                    :picker-options="bookingOpenTimePickerOption"
                  />
                </div>
              </el-form-item>
              <el-form-item>
                <div slot="label">
                  잔여 인원 노출
                  <span class="label-description">
                    ON으로 설정 시 앱에 수업마다 잔여 인원이 노출됩니다.
                  </span>
                </div>
                <div class="el-switch__wrapper">
                  <el-switch
                    v-model="form.is_remaining_quota_exposed"
                    class="el-switch__remaining_quota_exposed"
                  />
                  <div
                    v-if="isWhitePlan || isLightGreyPlan"
                    class="setting-item__mask"
                    @click.prevent="detectFunction(RESTRICT_FUNCTION_ID.SHOW_REMAIN)"
                  />
                </div>
              </el-form-item>
              <el-form-item>
                <div slot="label">
                  수업 리마인드 푸시 알림
                  <span class="label-description">
                    ON으로 설정 시 수업 시작 리마인드 푸시 알림이 발송됩니다.
                  </span>
                </div>
                <div class="el-switch__wrapper">
                  <el-switch
                    v-model="form.is_remind_alarm_avaliable"
                    class="el-switch__remind_alarm_avaliable"
                  />
                  <div
                    v-if="isWhitePlan || isGreyPlan || isLightGreyPlan"
                    class="setting-item__mask"
                    @click.prevent="detectFunction(RESTRICT_FUNCTION_ID.PUSH_ALERT)"
                  />
                </div>
              </el-form-item>
              <el-form-item v-show="form.is_remind_alarm_avaliable">
                <div slot="label">
                  푸시 알림 발송 시간
                  <span class="label-description">
                    수업 시작 몇 분/시간/일 전에 푸시 알림을 발송할지 정해주세요.
                  </span>
                </div>
                <el-input-time
                  v-model="form.remind_alarm_time"
                  :max-day-limit="7"
                />
                <div
                  v-if="isWhitePlan || isGreyPlan || isLightGreyPlan" 
                  class="setting-item__mask"
                  @click.prevent="detectFunction(RESTRICT_FUNCTION_ID.PUSH_ALERT)"
                />
              </el-form-item>
            </div>
          </div>
          <div class="card-box px-md-4 policy-card__left__second">
            <div class="single-form booking-policy-form__single-form">
              <el-form-item>
                <div slot="label">
                  예약 대기 인원 노출
                  <span class="label-description">
                    ON으로 설정 시 앱에 수업마다 예약 대기 인원이 노출됩니다.
                  </span>
                </div>
                <div class="el-switch__wrapper">
                  <el-switch
                    v-model="form.is_wait_member_exposed"
                    class="el-switch__wait_booking_member_exposed"
                  />
                  <div
                    v-if="isWhitePlan || isGreyPlan || isLightGreyPlan"
                    class="setting-item__mask"
                    @click.prevent="detectFunction(RESTRICT_FUNCTION_ID.WAITLIST)"
                  />
                </div>
              </el-form-item>
              <el-form-item>
                <div slot="label">
                  예약 확정 시간
                  <popover placement="right-start">
                    본 시간 기준으로 예약 대기자들을 포함한 최종<br>
                    예약 리스트가 확정됩니다.
                    <br><br>
                    본 시간 전까지만 예약 대기 및 대기 취소가 가능하<br>
                    며 이 이후로는 결원이 발생하더라도 더이상 예약<br>
                    대기 신청이 불가합니다.
                    <br><br>
                    <a
                      target="_blank"
                      href="https://intercom.help/fiflbox/ko/articles/5338080-%EC%98%88%EC%95%BD-%EB%8C%80%EA%B8%B0-%EC%84%A4%EC%A0%95%ED%95%98%EA%B3%A0-%EC%8B%B6%EC%96%B4%EC%9A%94#h_0d5a56e412"
                      style="color: #9b9b9b;"
                    >
                      더 자세히 알아보기 >
                    </a>
                  </popover>
                  <span class="label-description">
                    예약 대기자를 포함하여 최종적으로 예약을 확정할 시간을 예약/변경/취소 시간 정책 중 하나로 설정해 주세요.
                  </span>
                </div>
                <el-select
                  :value="expiredStandard"
                  ref="expiredSelectRef"
                  @change="syncExpiredStandard"
                >
                  <el-option
                    v-for="item in expiredPolicy"
                    :class="item.value === form.booking_expired_standard ? 'selected' : ''"
                    :key="item.key"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <div
                  v-if="isWhitePlan || isGreyPlan || isLightGreyPlan"
                  class="setting-item__mask"
                  @click.prevent="detectFunction(RESTRICT_FUNCTION_ID.TIME_FIXED)"
                />
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md ml-md-3 mt-md-0">
          <div class="card-box px-md-4 policy-card__right">
            <div class="single-form">
              <el-form-item>
                <div slot="label">
                  예약 가능 시간
                  <span class="label-description">
                    수업 시작 몇 분/시간/일 전까지 예약을 허용할지 정해주세요.
                    <popover placement="top">
                      '1시간'으로 설정할 경우 (10:00 수업 예시)<br>회원은 당일 9:00까지 예약을 신청할 수 있습니다.
                    </popover>
                  </span>
                </div>
                <el-input-time
                  v-model="form.booking_available_to"
                />
                <div
                  v-if="isWhitePlan || isGreyPlan || isLightGreyPlan"
                  class="setting-item__mask"
                  @click.prevent="detectFunction(RESTRICT_FUNCTION_ID.TIME_APPLY)"
                />
              </el-form-item>
              <el-form-item>
                <div slot="label">
                  예약 변경 가능 시간
                  <span class="label-description">
                    수업 시작 몇 분/시간/일 전까지 예약 변경을 허용할지 정해주세요.
                    <popover placement="top">
                      '1시간'으로 설정할 경우 (10:00 수업 예시)<br>회원은 당일 9:00까지 예약을 변경할 수 있습니다.
                    </popover>
                  </span>
                </div>
                <el-input-time
                  v-model="form.booking_changeable_to"
                />
                <div
                  v-if="isWhitePlan || isGreyPlan || isLightGreyPlan"
                  class="setting-item__mask"
                  @click.prevent="detectFunction(RESTRICT_FUNCTION_ID.TIME_EDIT)"
                />
              </el-form-item>
              <el-form-item>
                <div slot="label">
                  예약 취소 가능 시간
                  <span class="label-description">
                    수업 시작 몇 분/시간/일 전까지 예약 취소를 허용할지 정해주세요.
                    <popover placement="top">
                      '1시간'으로 설정할 경우 (10:00 수업 예시)<br>회원은 당일 9:00까지 예약을 취소할 수 있습니다.
                    </popover>
                  </span>
                </div>
                <el-input-time
                  v-model="form.booking_cancellable_to"
                />
                <div
                  v-if="isWhitePlan || isGreyPlan || isLightGreyPlan"
                  class="setting-item__mask"
                  @click.prevent="detectFunction(RESTRICT_FUNCTION_ID.TIME_CANCEL)"
                />
              </el-form-item>

              <div class="form-divide-line" />

              <el-form-item>
                <div slot="label">
                  출석체크 가능 시간
                  <span class="label-description">
                    수업 시작 몇 분/시간/일 전부터 출석체크를 허용할지 정해주세요.
                    <popover placement="top">
                      '1시간'으로 설정할 경우 (10:00 수업 예시)<br>회원은 당일 9:00부터 출석체크할 수 있습니다.
                    </popover>
                  </span>
                </div>
                <el-input-time
                  v-model="form.attendance_available_from"
                  :custom-unit-options="unitOptions.attendance_available_from"
                />
                <div
                  v-if="isWhitePlan || isLightGreyPlan"
                  class="setting-item__mask"
                  @click.prevent="detectFunction(RESTRICT_FUNCTION_ID.TIME_CHECKIN)"
                />
              </el-form-item>

              <el-form-item>
                <div slot="label">
                  지각 처리 시작 기준
                  <span class="label-description">
                    수업 시작 몇 분 후부터 지각으로 처리할지 정해주세요.
                    <popover placement="top">
                      ‘5분’으로 설정할 경우 (10:00 수업 예시)<br>
                      회원이 10:00 - 10:04 사이에 출석체크할 경우<br>
                      '출석'으로 인정되나 10:05 부터는 출석체크를 하더<br>
                      라도 '지각' 처리됩니다. 수업 종료 전까지 출석체크<br>
                      하지 않을 경우 자동으로 '결석' 처리됩니다.
                    </popover>
                  </span>
                </div>
                <el-input-time
                  v-model="form.late_from"
                  :fix-unit="1"
                />
                <div
                  v-if="isWhitePlan || isLightGreyPlan"
                  class="setting-item__mask"
                  @click.prevent="detectFunction(RESTRICT_FUNCTION_ID.TIME_LATE)"
                />
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="page === 'setting'"
        class="row no-gutters justify-content-end mt-3 mb-3"
      >
        <div class="col-auto">
          <el-loading-button
            class="gray"
            :is-loading="isSavingForm"
            @click="saveForm"
          >
            저장
          </el-loading-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import ElInputNumberOrNone from '@/components/element-ui/ElInputNumOrNone';
import ElInputTime from '@/components/element-ui/ElInputTime';
import {
  BOOKING_EXPIRED_STANDARD,
  TIME_UNIT,
  RESTRICT_FUNCTION_ID,
  RESTRICT_FUNCTION_NAME,
  RESTRICT_FUNCTION_MESSAGE
} from '@/constants';
import ElLoadingButton from '@/components/el-loading-button';
import Popover from '@/components/popover';
import ElInputWeek from '@/components/element-ui/ElInputDayWeek';
import { fiflboxApi } from '@/utils/api';
import { computedGetters } from '@/utils/vuex-helper';
import { confirmAllWaitingCancel } from './ConfirmMessageBoxes.js';

export default {
  name: 'BookingPolicyForm',
  components: {
    ElInputWeek,
    Popover,
    ElLoadingButton,
    ElInputTime,
    ElInputNumberOrNone
  },
  props: ['page', 'clickNextAction'],
  data() {
    return {
      RESTRICT_FUNCTION_ID,
      RESTRICT_FUNCTION_NAME,
      RESTRICT_FUNCTION_MESSAGE,
      form: {
        membership_system: 'COUNT',
        is_remaining_quota_exposed: true, // 잔여 인원 노출,
        is_remind_alarm_avaliable: false, // 수업 리마인드 푸시 알림
        is_wait_member_exposed: false, // 예약 대기 인원 노출
        booking_available_from: TIME_UNIT.MINUTE, // 예약 기간
        booking_available_to: TIME_UNIT.MINUTE * 30, // 예약 가능 시간
        booking_changeable_to: TIME_UNIT.HOUR * 5, // 예약 변경 가능 시간
        booking_cancellable_to: TIME_UNIT.DAY, // 예약 취소 가능 시간
        remind_alarm_time: TIME_UNIT.MINUTE * 30, // 푸시 알림 발송 시간
        attendance_available_from: TIME_UNIT.HOUR, // 츨석 체크 가능 시간
        late_from: TIME_UNIT.MINUTE * 5, // 지각 처리 시간
        booking_open_time: '00:00:00',
        booking_expired_standard: BOOKING_EXPIRED_STANDARD.CANCELABLE,
        booking_expired_time: TIME_UNIT.DAY
      },
      unitOptions: {
        attendance_available_from: [
          {
            value: TIME_UNIT.MINUTE,
            label: '분'
          },
          {
            value: TIME_UNIT.HOUR,
            label: '시간'
          }
        ]
      },
      expiredStandard: '',
      expiredPolicy: [
        {
          key: 'cancelable',
          value: BOOKING_EXPIRED_STANDARD.CANCELABLE,
          label: '예약 취소 가능 시간 정책과 동일하게 적용'
        },
        {
          key: 'changeable',
          value: BOOKING_EXPIRED_STANDARD.CHANGEABLE,
          label: '예약 변경 가능 시간 정책과 동일하게 적용'
        },
        {
          key: 'avaliable',
          value: BOOKING_EXPIRED_STANDARD.AVALIABLE,
          label: '예약 가능 시간 정책과 동일하게 적용'
        }
      ],
      hasData: false,
      isSavingForm: false,
      bookingOpenTimePickerOption: {
        step: '00:15',
        start: '00:00',
        end: '23:45'
      },
      checker: {
        is_point: false,
        is_count: false
      },
      updateBookings: []
    };
  },
  async created() {
    await this.syncPolicy();
    if (this.form.membership_system === 'COUNT') {
      this.checker.is_count = true;
    } else {
      this.checker.is_point = true;
    }
    if (!this.isBookingSystem) {
      this.form.is_remind_alarm_avaliable = false;
    }
  },
  computed: {
    ...computedGetters([
      'membershipSystem',
      'isWhitePlan',
      'isGreyPlan',
      'isLightGreyPlan'
    ]),
    isBookingSystem() {
      return this.$store.getters.getIsBookingSystem;
    },
    bookingOpenTime: {
      get() {
        const splited = this.form.booking_open_time.split(':');
        return `${splited[0]}:${splited[1]}`;
      },
      set(newValue) {
        this.form.booking_open_time = `${newValue}:00`;
      }
    }
  },
  methods: {
    confirmAllWaitingCancel,
    async syncPolicy() {
      await this.$store.dispatch('syncPolicy');
      this.form = await this.$store.getters.getPolicy;
      await this.syncExpiredStandard(this.form.booking_expired_standard);
    },
    async updatePolicy() {
      try {
        await fiflboxApi.v2.putPolicy(this.form);
        return true;
      } catch (err) {
        if (err.response.status === 400) {
          const { data } = err.response;
          if (data.error_code === '116') {
            const { error_detail: bookings } = data;
            this.updateBookings = bookings;
            const result = await this.confirmAllWaitingCancel(
              bookings,
              this.membershipSystem
            );
            return result;
          }
        }
      }
    },
    async saveForm() {
      this.isSavingForm = true;
      if (this.checker.is_count) {
        this.form.membership_system = 'COUNT';
      } else {
        this.form.membership_system = 'POINT';
      }
      if (!this.form.is_remind_alarm_avaliable) {
        this.form.remind_alarm_time = 30;
      }
      await this.syncExpiredTime(this.form.booking_expired_standard);

      const updateResult = await this.updatePolicy();
      let isConfirmNextStep = false;
      let resultMessage = '예약 정책이 변경됐습니다.';
      if (updateResult) {
        isConfirmNextStep = await this.bulkCancelWaitings();
      }
      if (isConfirmNextStep) {
        await this.updatePolicy();
      } else {
        resultMessage = '예약 정책이 변경이 취소되었습니다.';
      }
      await this.syncPolicy();
      this.$message(resultMessage);
      this.isSavingForm = false;
    },
    checkboxActionHandler(action) {
      switch (action) {
        case 'COUNT':
          this.checker.is_count = true;
          this.checker.is_point = false;
          break;
        case 'POINT':
          this.checker.is_point = true;
          this.checker.is_count = false;
          break;
      }
    },
    syncExpiredStandard(value) {
      this.form.booking_expired_standard = value;
      this.expiredStandard = this.expiredPolicy[value].label;
    },
    syncExpiredTime(value) {
      let expiredTime = this.form.booking_expired_time;
      switch (value) {
        case BOOKING_EXPIRED_STANDARD.CANCELABLE:
          expiredTime = this.form.booking_cancellable_to;
          break;
        case BOOKING_EXPIRED_STANDARD.CHANGEABLE:
          expiredTime = this.form.booking_changeable_to;
          break;
        case BOOKING_EXPIRED_STANDARD.AVALIABLE:
          expiredTime = this.form.booking_available_to;
          break;
      }
      this.form.booking_expired_time = expiredTime;
    },
    async bulkCancelWaitings() {
      const payload = {
        data: this.updateBookings,
        status: 'CANCELLED'
      };
      try {
        const { status } = await fiflboxApi.v1.patchBulkBookingStatus(payload);
        if (status === 200) {
          return true;
        }
        return false;
      } catch (err) {
        return false;
      }
    },
    async detectFunction(funcId) {
      const payload = {
        id: funcId,
        name: RESTRICT_FUNCTION_NAME[funcId],
        message: RESTRICT_FUNCTION_MESSAGE[funcId]
      };
      this.$store.commit('setRestrictFuncInfo', payload);
      this.$store.commit('setIsRestrictFunc', true);
    }
  }
};
</script>

<style lang="scss">
.el-switch {
  &.el-switch__remaining_quota_exposed,
  &.el-switch__remind_alarm_avaliable,
  &.el-switch__wait_booking_member_exposed {
    position: absolute;
    right: 0;
    width: 60px;
    height: 36px;

    @media screen and (max-width: 768px) {
      position: relative;
      right: auto;
      top: auto;
    }
  }
}

.el-switch__wrapper {
  position: absolute;
  right: 0;
  top: -40px;
  width: 60px;
  height: 36px;
  @media screen and (max-width: 768px) {
    position: relative;
    right: auto;
    top: auto;
  }
}

.setting-item__mask {
  cursor: pointer;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
}

.booking-policy-form__single-form {
  span.label-description {
    line-height: 17px !important;
  }
  .booking-policy-form__single-form__checkboxs {
    display: flex;
    .el-checkbox {
      margin: 0;
      height: 50px;
      border-radius: 6px;
      padding: 10px;
      display: flex;

      &:last-child {
        margin-left: 10px;
      }
      .el-checkbox__input {
        width: 14px;
        height: 14px;
        margin: auto;
      }
      .el-checkbox__label {
        margin: auto;
        line-height: 20px;
        font-size: 14px;
        font-weight: normal;
      }
    }
  }
}
.policy-card__left__first {
  margin-bottom: 15px;
}

.policy-card__left__second {
  @media screen and (max-width: 768px) {
    margin-bottom: 15px;
  }
}

.policy-card__right {
  height: 100%;
}
</style>
